import { RoleType, STATUS } from 'app/constants/request'
import { DemoMaterialRequest } from 'app/models/RequestFlow'

export const getDemoCardApprovalState = (
  item: DemoMaterialRequest,
  roleType?: string,
  currentUserId?: number | null,
) => {
  const latestStatus = (item.latest_status || '').toUpperCase()
  const isApprovedRequest =
    latestStatus.includes('APPROVED') ||
    (roleType === RoleType.L1 &&
      [STATUS.L2_PENDING, STATUS.L2_APPROVED, STATUS.L2_REJECTED].includes(latestStatus))
  const isApprovedByYou = item.approvers?.some(
    approver =>
      approver.id === currentUserId &&
      (approver.status || '').toUpperCase().includes('APPROVED'),
  )

  return { latestStatus, isApprovedRequest, isApprovedByYou }
}
